module.exports = __webpack_public_path__ + "static/assets/mdi_face-male.svg";